import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-modal-vn-data',
  templateUrl: './modal-vn-data.component.html',
  styles: []
})
export class ModalVnDataComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  dataModelEmail = {
    kont_enmIdent_KontaktTyp: 3,
    kontVal: ''
  };
  dataModelEmailClone: any;

  dataModelPhone = {
    kont_enmIdent_KontaktTyp: 1,
    kontVal: ''
  };
  dataModelPhoneClone: any;
  comment = '';
  reserve = '';
  selbstbeteiligung = '';

  phoneTypList: any[] = [];

  constructor(
    private modalSvc: ExgModalService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    const allTypes = this.enumSvc.getEnumerationList('KontaktTyp');
    this.phoneTypList = allTypes.filter((e: any) => e.enmIdent === 1 || e.enmIdent === 5);

    this.dataModelEmailClone = this.appSvc.helperObj.clone(this.dataModelEmail);
    this.dataModelPhoneClone = this.appSvc.helperObj.clone(this.dataModelPhone);
  }

  isValidEmail(): boolean {
    if (!this.dataModelEmailClone.kontVal || this.dataModelEmailClone.kontVal.trim() === '') {
      return true;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.dataModelEmailClone.kontVal.trim());
  }

  isValidCurrency(val: string): boolean {
    if (!val || val.trim() === ''){
      return true;
    }
    const standard = val.trim().replace(',', '.');
    return /^\d+(\.\d{1,2})?$/.test(standard);
  }
  canSave(): boolean {
    if (!this.isValidEmail()) {
      return false;
    }
    if (!this.isValidCurrency(this.reserve)) {
      return false;
    }
    if (!this.isValidCurrency(this.selbstbeteiligung)) {
      return false;
    }

    return true;
  }

  getRemoveHint(email: any): string {
    return `Vorhandene E-Mail-Adresse ${email.kontVal} bitte löschen.`;
  }

  isEmailMarked(email: any): boolean {
    if (!this.comment){
      return false;
    }
    return this.comment.includes(this.getRemoveHint(email));
  }

  removeEmail(email: any): void {
    this.comment = ((this.comment || '') + '\n' + this.getRemoveHint(email)).trim();
  }

  undoRemoveEmail(email: any): void {
    const hint = this.getRemoveHint(email);
    this.comment = this.comment.replace('\n' + hint, '').replace(hint, '').trim();
  }

  cancel(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (!this.canSave()) {
      return;
    }

    const result: any = {};

    if (this.appSvc.helperObj.changed(this.dataModelEmail, this.dataModelEmailClone)) {
      result.email = {
        kontVal: this.dataModelEmailClone.kontVal.trim(),
        kont_enmIdent_KontaktTyp: this.dataModelEmailClone.kont_enmIdent_KontaktTyp
      };
    }

    if (this.appSvc.helperObj.changed(this.dataModelPhone, this.dataModelPhoneClone)) {
      result.phone = {
        kontVal: this.dataModelPhoneClone.kontVal.trim(),
        kont_enmIdent_KontaktTyp: this.dataModelPhoneClone.kont_enmIdent_KontaktTyp
      };
    }

    if (this.comment && this.comment.trim().length > 0) {
      result.comment = this.comment.trim();
    }
    result.reserve = this.reserve ? this.reserve.replace(',', '.') : undefined;
    result.selbstbeteiligung = this.selbstbeteiligung ? this.selbstbeteiligung.replace(',', '.') : undefined;

    this.modalSvc.action(result);
  }
}
